import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Inject, Optional, Renderer2, AfterViewInit, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective, BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { RestService } from '../../../../shared/rest.service';
import { CustomValidator } from '../../../../shared/customValidators';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { searchPayload } from '../../../../utils/search-functions';
import { UserService } from '../../../../pages/com.usblick.common/auth/user.service';
import { of, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AddressesService } from '../../service/addresses.service';
import * as dayjs from 'dayjs';
import { setting } from '../../../../../../setting';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { take, takeUntil } from 'rxjs/operators';
import { ItineraryService } from 'app/shared/itinerary.service';
import { MAT_DIALOG_DATA, MatAutocomplete, MatDialogRef } from '@angular/material';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { DateRangePickerService } from 'app/shared/date-range-picker/date-range-picker.service';

interface Addons {
  hasPreExistingCondition: boolean;
  isPregnant: boolean;
  isOnTrip: boolean;
}

interface PaxOption {
  age: number;
  pregnancyWeeks: number;
  addons: Addons;
}



@Component({
  selector: 'usb-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
  providers: [DatePipe, AddressesService]
})
export class InsuranceComponent implements OnInit, AfterViewInit {

  @Input() form: FormGroup;
  @Output() payload = new EventEmitter<any>();
  @Output() results = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() origin = new EventEmitter<any>();
  @Input() _close: boolean;
  @Output() modal = new EventEmitter<string>();

  @ViewChild('dpDeparture') datepickerDeparture: BsDatepickerDirective;
  @ViewChild('dpArrival') datepickerArrival: BsDatepickerDirective;
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild('mySelect') mySelect!: ElementRef;
    @ViewChild('triggerButton') triggerButton: ElementRef;
    @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
@ViewChild('auto') auto: MatAutocomplete;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('dateRangePicker') dateRangePicker: DaterangepickerDirective;

  destinationOptions: Observable<any[]> = of([]);
  destinationOptions_: Observable<any[]>= of([]);

  destineVale: boolean;
  originValue: boolean;
  selectediataCodeDestiny: any;
  selectediataCodeOrigin: any;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };

  _findData: boolean;
  _resultsQuery: any;
  _form: FormGroup;
  _maxPersons: any;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  isCollapsed = false;
  aged: number;
  validate = false;
  selectedDestiny: any;
  _longDestination: string;
  destiny: any;
  originVar: any;
  roomsAndPassengers: string;
  passengers: string;
  dateRange: any = { start: null, end: null };
  country: any;
  selectNationalityForm: boolean = false;
  selectNationalityName: string = '';
  isHoveredCancelDate: boolean;
  hotel_id: number;
  hotel_name: string = '';
  country_name: string = '';
  province_name: string = '';
  isLoading_ = false;
  beginInputValue: any;
  begin: any;
  end: any;
  endInputValue: any;
  minDate: dayjs.Dayjs = dayjs().subtract(0, "days");
  maxDate: dayjs.Dayjs = dayjs().add(12, "month");
  public getClientsSettingAppBooking: any;
  minDateDeparture: Date;
  maxDateArrival: Date;
  _maxAdults: any;
  _maxChildren: any;
  bgClientColor: string;
  startDate: any;
    endDate: any
  showModal: boolean = false;
  titleModal: string = 'Advertencia';
  messageModal: string = 'Cree un file en la barra superior para poder iniciar una búsqueda';
  isHovered = false;
  isHoverConfirm: boolean;
  public countriesData: any[] = [];
  public filteredCountries: any[] = [];
  public selectNationality: string = '';
  bsModalRef?: BsModalRef;
  componentResults: boolean = false;
  isOptionalExpanded: boolean = false;
  ageTimeout: any;
  qtyPax: number = 1;
  pregnantWeekends: any[] = [];
    componentResultsFirstCharge: boolean = true;
      loadingData: boolean = false;
        routerStorage: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private observer!: MutationObserver;
    private calendarSync: DateRangePickerService;
        openDropdownIndexes = new Set<number>();
  openPregnancyIndexes = new Set<number>();
  agencyId:any;
  agencyCountry: any;
  private closing = false;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Handle passenger panel collapse
    if (this.isCollapsed && !this.closing) {
      const clickedTrigger = this.triggerButton?.nativeElement.contains(event.target);
      const clickedSelector = this.cardSelectorRoom?.nativeElement.contains(event.target);
      if (!clickedTrigger && !clickedSelector) {
        this.closing = true;
        this._confirm();
      }
    }

    // Handle dropdown close
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-multiselect')) {
      this.openDropdownIndexes.clear();
      this.openPregnancyIndexes.clear();
    }
  }
  typeTrip = [
    {label: 'Viaje vacacional', value: 'Viaje Vacacional'},
    {label: 'Viaje estudio o trabajo', value: 'Viaje Estudio o Trabajo'},
    {label: 'Multiviaje', value: 'Multiviaje'},
    {label: 'Corporate VIP', value: 'Corporate'},
    {label: 'Deportes', value: 'Deportes'},
    {label: 'Viajes en crucero', value: 'Crucero'},
  ]

destinyInsurance: any[] = [];

  passengerFilter = [
    {label: 'Preexistencia', filter: 'hasPreExistingCondition'},
    {label: 'Embarazada', filter: 'isPregnant'},
    {label: 'En viaje', filter: 'isOnTrip'}
  ]


    private destinationSubscription: Subscription;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _restService: RestService,
    private modalService: BsModalService,
    public toastr: ToastrService,
    private datePipe: DatePipe,
    public userService: UserService,
    private _itineraryService: ItineraryService,
    private renderer: Renderer2,
      @Inject(MAT_DIALOG_DATA) public data: any,
      @Optional() public dialogRef: MatDialogRef<InsuranceComponent>
  ) {
    this._maxPersons = Array.from({length: 10}, (_, i) => i + 1);
    this.pregnantWeekends = Array.from({length: 36}, (_, i) => i + 1);
    this.minDateDeparture = new Date();
    this.maxDateArrival = new Date();
    this.dpConfig.containerClass = "theme-red";
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.aged = 0;
    this.calendarSync = new DateRangePickerService();
  }
  ngAfterViewInit(): void {
    this.updateCheckboxColor();

       setTimeout(() => {
        this.setupAutocompleteStyles();
    });

    // this.cdr.detectChanges();
  }


    private setupAutocompleteStyles(): void {
    if (this.auto) {
        this.auto.opened.subscribe(() => {
            setTimeout(() => {
                // Buscar todos los overlays y tomar el último (el más reciente)
                const overlays = document.querySelectorAll('.cdk-overlay-pane');
                const overlay = overlays[overlays.length - 1]; // El último abierto

                if (overlay) {
                    (overlay as HTMLElement).style.minWidth = '30%';
                    (overlay as HTMLElement).style.width = 'fit-content';
                    (overlay as HTMLElement).style.maxWidth = '90vw';
                }
            });
        });
    }

}

  ngOnInit(): void {
     this.componentResults = this.data && this.data?.component === 'results' ? true : false;
         if(this.componentResults) {
      this.loadingData = true;
    }
    this.roomsAndPassengers = "Rooms and passengers";
    this.agencyData();
    this.getInsuranceDestination();
    this.initForm();

    }

  agencyData(): void {
    let agency = JSON.parse(localStorage.getItem("selectedAgency"));

    if(agency) {
      this.agencyId = agency.agency_id;
      this.agencyCountry = agency.country;
    }else{
      this.agencyId = this.userService._agencyID;
    }
  }

    getInsuranceDestination(): void {
      this._restService.doGet('api', '/utilities/searchinsurance').subscribe({

        next: (response: any) => {
          if (response && Array.isArray(response)) {
            this.destinyInsurance = response;
          } else {
            this.toastr.error('No se pudieron cargar los destinos de seguro disponibles. Inténtalo de nuevo más tarde.');
          }
        },
      })
    }

onSelectOpened() {
  setTimeout(() => {
    this.updateCheckboxColor();
    this.setupCheckboxObserver();
  }, 0);
}

  private setupCheckboxObserver() {
    const panel = document.querySelector('.mat-select-panel');
    if (!panel) return;

    // Configurar observer para detectar cambios en las clases
    this.observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        this.updateCheckboxColor();
      }
    });

    // Observar cambios en todos los checkboxes del panel
    const checkboxes = panel.querySelectorAll('.mat-pseudo-checkbox');
    checkboxes.forEach(checkbox => {
      this.observer.observe(checkbox, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  onSelectClosed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }


  initForm(): void {


  this._form = this.fb.group({
        // Search basic
        origin: new FormControl(null, Validators.required),
        destination: new FormControl(null, Validators.required),
        beginDateEndDate: new FormControl("", Validators.required),
        serviceType: new FormControl(null),
        qtyPax: new FormControl(1, [Validators.required, Validators.min(1)]),
        // paxesAges: new FormControl([18]),
        paxes: this.fb.array([]),
        qtyProduct: new FormControl(1, [Validators.required, Validators.min(1), Validators.max(7)]),
        wsp_phone_contact: new FormControl(""),
        email_contact: new FormControl("")
      });

      const control = this._form.get('paxes') as FormArray;

      control.push(this.fb.group({
                                    age: [18, [Validators.required, Validators.min(18)]],
                                    pregnancyWeeks: null, //Cantidad semanas de embarazo
                                    addons:[]
      }))

      if(this.componentResults) {

        this.getCountries(true);
      }
  }

    /**
   * Devuelve los controles de un FormArray
   *
   * Utilizado para iterar sobre los controles dentro de un `FormArray`
   * en una plantilla o lógica de componentes.
   *
   * @form -> instancia de `FormGroup`
   * @key -> nombre del control que contiene el `FormArray`
   * @return -> lista de controles dentro del `FormArray`
   */

    formArray(form: FormGroup, key: string) { return (<FormArray>form.get(key)).controls; }


  // realiza la busqueda en el endpoint
  _onSubmit(form: FormGroup, event?: Event, dummy?: Object) {
    const _payloadForm = [];
    this.originValue = ((this.selectediataCodeOrigin !== undefined) && (this.selectediataCodeOrigin !== null));
    this.destineVale = ((this.selectediataCodeDestiny !== undefined) && (this.selectediataCodeDestiny !== null));

    if (form.valid) {
      if (event) {
        event.preventDefault();
      }

      const _payload = searchPayload('INSURANCE', this.dateRange, form, this.selectediataCodeDestiny, this.selectediataCodeOrigin);
      _payload.providersId = this.userService._providerId;
      _payload.agencyCountry = this.agencyCountry;
      form.value.begin = this.selectNationalityName;

      const destinySelected = this.destinyInsurance.find(c => c.name === _payload.insurances?.destination);
      const formSave = form.value;
      formSave.destination = destinySelected

      localStorage.setItem("form", JSON.stringify(formSave));
      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }


      _payloadForm[0] = _payload;
      localStorage.setItem("payload", JSON.stringify(_payloadForm));

      if(this.componentResults) {
        this.dialogRef.close(_payload);
        localStorage.setItem('origin', 'INSURANCE');
      } else {

          this._emitLoading(true);
       this._restService.doPost('app', 'search', _payload).subscribe(
         (response:any) => {

           if (response !== null && response.results && Array.isArray(response.results) && response.results.length > 0) {
           this.payload.emit([searchPayload('INSURANCE', this.dateRange, form, this.selectediataCodeDestiny, this.selectediataCodeOrigin)]);
             this._colocarSearchIdEnlosInsurances(response);
             this._handleResponse(response, 'INSURANCE', form);
             this._emitOrigin('INSURANCE');
             this._emitLoading(false);
             this._router.navigate(['/results']);
           } else {
             this._emitLoading(false);
              const initialState: ModalOptions = {
                initialState: {
                  message: '',
                  confirmText: 'Cerrar',
                  cancelText: 'Volver a intentar',
                  showCancelButton: true,
                  size: 'sm',
                }
              };
              const modalOptions = Object.assign({}, initialState, this.config);
              this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
           }
         },
         error => {
           this._emitLoading(false);
           const initialState: ModalOptions = {
             initialState: {
               message: 'Ocurrió un error al intentar encontrar productos. Inténtalo de nuevo'
             }
           };

           this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
           const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {

                 if (result) {
                   this._onSubmit(form, event);
                 } else {
                   this.bsModalRef.hide();
                   this._router.navigate(["/home"]);
                 }


               confirmSubscription.unsubscribe();
             });
         });

      }

    } else {

    }
  }

  getValueAddonsPregant(index): boolean {

    const selectedAddons = this.paxes.at(index).get('addons')?.value;

    return selectedAddons?.includes('isPregnant');
  }

  getFormattedDate(date: any, format: string): any {
    if (format === 'time') {
      const _date = date ? this.datePipe.transform(date, 'HH:mm') : '13:00';
      return _date;
    } else {
      const _date = date ? this.datePipe.transform(date, 'yyyy-MM-dd') : '2018-05-30';
      return _date;
    }
  }

  _emitOrigin(origin: any) {
    this.origin.emit(origin);
  }

  _colocarSearchIdEnlosInsurances(response: any) {
    response.results.forEach(obj => {
      obj.searchId = response.searchId;
    });
  }

  _handleResponse(response: any, categoryName: string, form: FormGroup) {
    if (response && response.results != null) {
      try {
        this._resultsQuery = response.results;
        this._resultsQuery.categoryName = categoryName;
        this._resultsQuery.arrivalDate = form.value['arrivalDate'];

        if (!response.results.length) {
          this._resultsQuery.noResultMessage = 'No results found for the search';
        }
        // se anexa el formulario actual
        this._resultsQuery.form = form;
        this.results.emit([this._resultsQuery]);
      } catch (e) {
        this._resultsQuery = [];
        this._restService.page = 1;
      }
    } else {
      this._resultsQuery = [];
      this._resultsQuery.noResultMessage = 'No results found for the search';
      this.results.emit(this._resultsQuery);
    }
  }

  _confirm() {
    this.isCollapsed = false;
    this.setPassanger();


        setTimeout(() => {
    this.closing = false;
  }, 100);
  }

  _openModal() {
    this.isCollapsed = true;
    this.validate = false;
    this.closing = false;
    this._close = false;
    setTimeout(() => {
      this.modal.emit('true');
    }, 100);
  }

  _over() {
    //console.log('here')
    this.modal.emit('false');
  }

  clickOutside(event: any) {
    this.setPassanger();
  }



  // Getter para fácil acceso
get paxes(): FormArray {
  return this._form.get('paxes') as FormArray;
}

// Método para actualizar edades
  settingAge(value: string, index: number): void {
  // Clear previous timeout if exists
  if (this.ageTimeout) {
    clearTimeout(this.ageTimeout);
  }

  // Set new timeout
  this.ageTimeout = setTimeout(() => {
    const numericValue = Number(value);

    if (isNaN(numericValue) || numericValue < 18) {
      this.paxes.at(index).get('age').setValue(18);
    }
    else if (numericValue > 120) {
        this.paxes.at(index).get('age').setValue(120);
    }
    else {
      this.paxes.at(index).get('age').setValue(numericValue);
    }

  }, 1500); // 1500ms delay
}

  /**
 * Agrega o elimina controles de edad para niños según cantidad seleccionada
 *
 * Este método ajusta dinámicamente los elementos del `FormArray` relacionado
 * a la edad de los niños. Si la cantidad seleccionada es mayor a los existentes,
 * se agregan nuevos; si es menor, se eliminan.
 *
 * @key -> nombre del `FormArray` en el formulario (por ejemplo 'childAges')
 * @key2 -> nombre del campo que indica la cantidad seleccionada (por ejemplo 'children')
 */

  _addPax(): void {
  const qty: number = +this._form.value.qtyPax;
  const agesArray = this.paxes;

  if (qty > agesArray.length) {
    for (let i = agesArray.length; i < qty; i++) {
      agesArray.push(this.fb.group({
        age: [18, [Validators.required, Validators.min(18)]],
        pregnancyWeeks: null, //Cantidad semanas de embarazo
        addons: []
      }));
    }
  } else {
    while (agesArray.length > qty) {
      agesArray.removeAt(agesArray.length - 1);
    }
  }
}

  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }


  /***********************************************Auto Complete********************************************/
  _myListFormatter(data: any): string {
    return `${data['name']} (${data['iataCode']})`;
  }

  _myCallbackDestiny(data: any): string {
    this.selectediataCodeDestiny = data['iataCode'];
    return `${data['name']} (${data['iataCode']})`;
  }

  _myCallbackOrigin(data: any): string {
    this.selectediataCodeOrigin = data['iataCode'];
    return `${data['name']} (${data['iataCode']})`;
  }

  /***********************************************Auto Complete********************************************/

  setPassanger() {
    let paxes = this._form.value['qtyPax'];
    let ages = this._form.value['paxes'].map((c: PaxOption) => {return c.age});
    let noSelected = (parseInt(paxes) === 0);

    let passengersText = "Pasajeros";

    if (!noSelected) {
      passengersText = `${paxes} ${paxes === 1 ? 'Pasajero' : 'Pasajeros'}`;

      // Agregar edades si existen
      const validAges = ages.filter(age => age != null && age !== '');
      if (validAges.length > 0) {
        passengersText += ` - ${paxes === 1 ? 'Edad' : 'Edades'}: ${validAges.join(', ')}`;
      }
    }

    this.passengers = noSelected ? "Pasajeros" : passengersText;

  }


  async nextDate(event: any){
    if(event!==null){
      await this.datepickerArrival.toggle();
      this.datepickerDeparture.toggle();
      return;
    }
  }


    updateMySelection(event: any) {
    if (event) {
      this.destiny = event.city_name ? event.city_name : "";
      this.selectedDestiny = event.city_iata_code ?  event.city_iata_code : "";
      this._longDestination = event.city_name ? event.city_name : "";
      this.selectedDestiny =  event.city_iata_code ?  event.city_iata_code : "";
      this.country = event.country_iata_code ? event.country_iata_code : "";
      this.country_name = event.country_name ? event.country_name : "";
      this.province_name = `${event.city_province ? ', ' : ''}${event.city_province ? event.city_province : ''}`;
      if(!this.country) {
        this.hotel_id = event.id ? event.id : "";
        this.hotel_name = event.name ? event.name : "";
        this.country = event.country_code ? event.country_code : "";

      }
    }
  }


  capitalize(val: any) {
    if(val !== undefined && val !== null) {
      return val
        .toLowerCase()
        .trim()
        .split(" ")
        .map((v) => v[0].toUpperCase() + v.substr(1))
        .join(" ");
    }
  }

    displayFn(name: any) {
    if (name) {
      if(name.name !== undefined) {
        return name.name;
      }
      if (name.city_name !== undefined) {
        return name.city_name;
      }
    }
  }

  /**
 * Método para obtener todas las ubicaciones según el tipo.
 *
 * Este método asigna valores a las ubicaciones de origen y destino en el formulario, basándose en el tipo
 * (origen o destino) y los datos proporcionados. Además, establece valores y valida los campos en el formulario.
 *
 * @keyword -> objeto que contiene la información de la ubicación, como `destination_code`, `id`, `address`.
 * @type -> tipo de ubicación, que puede ser 'origin' o 'destination'.
 */
getLocationsAll(keyword: any, inputType: string) {
  if (keyword) {
    switch (inputType) {

      case 'origin':

          this.begin= { id: keyword.id};
          this._form.get('origin').setValue(keyword); // Asignamos el objeto completo
          this._form.get('origin').setErrors(null);
          this._form.get('origin').updateValueAndValidity();

          if (keyword?.iata) {
            this.selectediataCodeOrigin = keyword.iata;
            this.beginInputValue = `${keyword.name}, ${keyword.country_name} (${keyword.iata})`;
            this.begin['address']= keyword.iata.replace(/[()]/g, '');
            this.begin['type']= 'airport';
            this.begin['origin'] = keyword.country_code;
          } else if (keyword?.hotel_name) {
            this.selectediataCodeOrigin = keyword.address;
            this.beginInputValue = `${keyword.hotel_name}, ${keyword.city_name}`;
            this.begin['address']= keyword.address.replace(/[()]/g, '');
            this.begin['type']= 'hotel';
            this.begin['origin'] = keyword.destination_code;
          } else if (keyword?.city_iata) {
            this.selectediataCodeOrigin =  keyword.city_iata;
            this.beginInputValue =  `${keyword.city_name}, ${keyword.city_province}, ${keyword.country_name}`;
            this.begin['address']= keyword.city_iata.replace(/[()]/g, '');
            this.begin['type']= 'destination';
            this.begin['origin'] = keyword.city_iata;
          }

        if(keyword.id === this._form.get('origin').value?.id && this.begin['type'] === this.end?.['type']) {
          this.toastr.info('El pickup no puede ser igual que el dropoff');
          this.resetInputsOriginDestination('origin');
          return;
        }

        break;
      case 'destination':



          this.end = { id: keyword.id};

          this._form.get('destination').setValue(keyword); // Asignamos el objeto completo
          this._form.get('destination').setErrors(null);
          this._form.get('destination').updateValueAndValidity();

          if (keyword?.iata) {
            this.selectediataCodeDestiny = keyword.iata;
            this.endInputValue = `${keyword.name}, ${keyword.country_name} (${keyword.iata})`;
            this.end['address']= keyword.iata.replace(/[()]/g, '');
            this.end['type']= 'airport';
              this.end['destination'] = keyword.country_code;
          } else if (keyword?.hotel_name) {
            this.selectediataCodeDestiny = keyword.address;
            this.endInputValue = `${keyword.hotel_name}, ${keyword.city_name}`;
            this.end['address']= keyword.address.replace(/[()]/g, '');
            this.end['type']= 'hotel';
             this.end['destination'] = keyword.destination_code;
          } else if (keyword?.city_iata) {
            this.selectediataCodeDestiny = keyword.city_iata;
            this.endInputValue = `${keyword.city_name}, ${keyword.city_province}, ${keyword.country_name}`;
            this.end['address']= keyword.destination_code.replace(/[()]/g, '');
            this.end['type']= 'destination';
            this.end['destination'] = keyword.city_iata;
          }

        if(keyword.id === this._form.get('destination').value?.id && this.end['type'] === this.begin?.['type']) {
          this.toastr.info('El dropoff no puede ser igual que el pickup');
          this.resetInputsOriginDestination('destination');
          return;
        }

        break;
    }
  }
}

/**
 * Resetea los valores de origen o destino
 *
 * Este método se utiliza para limpiar los campos del formulario
 * relacionados con el origen o destino, dependiendo del tipo recibido.
 *
 * @type -> parámetro de tipo string que puede ser 'origin' o 'destination'
 *
 * 'origin':
 *  - Limpia `originInputValue`
 *  - Setea el campo 'firstOrigin' del formulario en null
 *  - Reinicia `pickup` y `selectediataCodeOrigin`
 *
 * 'destination':
 *  - Limpia `destinationInputValue`
 *  - Setea el campo 'firstDestination' del formulario en null
 *  - Reinicia `dropoff` y `selectediataCodeDestiny`
 *
 * @form -> formulario reactivo al que se le reinician campos específicos
 */
resetInputsOriginDestination(type: string) {
  switch(type) {
    case 'origin':
      this.beginInputValue = undefined;
      this._form.get('origin').setValue(null);
      this.begin = undefined;
      this.selectediataCodeOrigin = undefined;
      break;
    case 'destination':
      this.endInputValue = undefined;
      this._form.get('destination').setValue(null);
      this.end = undefined;
      this.selectediataCodeDestiny = undefined;
      break;
    default:
      break;
  }
}

 endDateClicked($event: any): void {
    // Convertimos a Day.js las fechas para garantizar consistencia
    const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf('day');
    const selectedEndDate = dayjs($event.endDate.$d).startOf('day'); // Normaliza al inicio del día
    this.endDate = $event;
    // Validar si la fecha de fin es inválida, igual o anterior a la fecha de inicio
    if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {

      this.toastr.warning('Debe elegir mínimo un día de diferencia con el día de inicio');


      this._form.get('beginDateEndDate')?.setValue(null); // Limpia el campo en el formulario

      setTimeout(() => {
        this.picker.clear(); // Limpia cualquier selección previa del datePicker
        this.picker.open(); // Reabre el calendario para seleccionar una nueva fecha
        // Resetea el rango de fechas y el formulario
      }, 100);
    } else {
      this.dateRange = { start: selectedStartDate, end: selectedEndDate };
    }
  }

    startDateClicked($event) {
        this.endDate = null;
        this.startDate = $event;
        this.onDateRangeChange();
    //  this.maxDate = moment($event.startDate._d).add(1, 'month');
  }

  onDateRangeChange(): void {
    // Ver si dateRange tiene startDate y endDate
    if (this.startDate && !this.endDate) {
        // Si tiene startDate y NO tiene endDate (aún no completó el rango)
            this.calendarSync.setStartDate(this.startDate ? this.startDate : this.dateRange.start);
        }
        // Si tiene startDate y endDate (rango completo)
    if (this.startDate && this.endDate) {
            this.calendarSync.clearStartDate();
        }
    }


  /**
 * Abre el modal principal
 *
 * Este método establece la propiedad `showModal` en `true`
 * para mostrar el modal asociado.
 *
 * @showModal -> estado booleano que determina si el modal está activo
 */
fileActive() {
  this.showModal = true;
}

/**
 * Método para actualizar el color del botón de confirmación.
 *
 * Este método cambia el color de fondo del botón de confirmación dependiendo de si el usuario está pasando el mouse sobre él
 * o no. El color de fondo se obtiene de la configuración global del cliente.
 */
updateButtonColorConfirm() {
  const button = document.querySelector('.btn-choice-confirm') as HTMLElement;
  if (this.isHoverConfirm) {
    button.style.backgroundColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
  } else {
    button.style.backgroundColor = 'white';
  }
}

  getCountries(researchData?: boolean) {
    this._itineraryService._restService.doGet("api", "/utilities/countries")
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (res: any) => {
        this.countriesData = res.Countrys;
        this.filteredCountries = this.countriesData;

        if(this.filterCountries && this.filterCountries.length > 0 && this.componentResults) {

          if(this.componentResultsFirstCharge) {

            this.formPatchValue();
          }
          this.componentResultsFirstCharge = false;
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }


    /**
   * Parchea el formulario principal con valores provenientes de datos existentes
   *
   * Este método complejo reconstruye y popula el formulario basado en datos preexistentes
   * de una categoría específica (actualmente solo categoría 1 - Hoteles). Realiza parsing
   * de fechas, configuración de habitaciones y búsqueda de destinos de forma asíncrona.
   *
   * @returns {void}
   *
   * @prerequisites
   * - Requiere `this.data` con propiedad `category` y `payload`
   * - Solo procesa categoría 1 (Hoteles) actualmente
   *
   * @process
   * 1. Parsing y conversión de fechas (arrivalDate, departureDate)
   * 2. Patch de valores básicos al formulario
   * 3. Configuración dinámica de habitaciones con `getRoomConfiguration`
   * 4. Búsqueda asíncrona de destino para actualizar selección
   * 5. Actualización final de valores del formulario
   *
   * @dataFlow
   * - payload → Parsing fechas → Patch formulario → Config habitaciones → Búsqueda destino → Final patch
   *
   * @asyncOperations
   * - Suscripción a `destinationOptions` para encontrar y actualizar selección de destino
   * - Uso de `take(1)` para completar la suscripción automáticamente
   *
   * @errorHandling
   * - Búsqueda en múltiples fuentes (cities, airports, hotels) para encontrar destino
   * - Fallback sequences si no encuentra en primera opción
   */
  formPatchValue(): void {

    if(this.data && this.data?.category) {
          if(!this.data.payload) {
            this.loadingData = false;
            return;
          }


          if(this.data.category !== this.data.payload[0].categoriesId[0]) {
              this.loadingData = false;
              return;
            }

          const payload = this.data.payload[0];

          if(!payload) {
              this.loadingData = false;
              return;
          }
                      // Para arrivalDate
            const [arrivalYear, arrivalMonth, arrivalDay] = payload.dateBegin.split('-');
            let dateBegin = new Date(Number(arrivalYear), Number(arrivalMonth) - 1, Number(arrivalDay));

            // Para departureDate (mismo método)
            const [departureYear, departureMonth, departureDay] = payload.dateEnd.split('-');
            let dateEnd = new Date(Number(departureYear), Number(departureMonth) - 1, Number(departureDay));


            if(isNaN(dateBegin.getTime())){
              dateBegin = dayjs(payload.dateBegin).startOf('day').toDate();
            }

            if(isNaN(dateEnd.getTime())){
               dateEnd = dayjs(payload.dateEnd).startOf('day').toDate();

            }

             this._form.patchValue({
              destination: payload.insurances.destination,
              qtyProduct: payload.insurances.paxList.length,
              serviceType: payload.insurances.tripType,
              origin: payload.insurances.origin,
              wsp_phone_contact: payload.wsp_phone_contact ? payload.wsp_phone_contact : "",
              email_contact: payload.email_contact ? payload.email_contact : "",
              beginDateEndDate: {
                start:  dateBegin,
                end: dateEnd
              }
            });

            // const country = this.filteredCountries.find(c => c.country_code === payload.insurances.origin);
            // setTimeout(() => {

              this.updateMySelectionNationality(payload.insurances.origin);
            // }, 100);
            this.loadingData = false;

    }
  }

    filterCountries(searchText: string) {
    if (searchText) {
      this.filteredCountries = this.countriesData.filter(country =>
        country.country_name.toLowerCase().includes(searchText.toLowerCase())
      );
    } else {
      this.filteredCountries = this.countriesData;
    }
  }

  displayCountry = (country: any) => {
    if (!this.filteredCountries) {
      console.error('filteredCountries is not defined');
      return '';
    }
    let countryData = this.filteredCountries.find(c => c.country_code === country);
    if(country === null) {
      countryData = null;
    }
    return countryData ? `${countryData.country_name}` : '';
  }

    updateMySelectionNationality(event: any) {
    if(event) {
      this._form.get('origin').setValue(event);
      this._form.get('origin').setErrors(null);
      this._form.get('origin').updateValueAndValidity();
      this.selectNationalityName = this.filteredCountries.find(c => c.country_code == event)?.country_name;
      this.selectNationality = event;
    }
  }

  /**
 * Confirma la acción y cierra el modal
 *
 * Este método es un wrapper de `closeModal()`, usado cuando el usuario
 * confirma una acción dentro del modal.
 *
 * @uses closeModal -> cierra el modal actual
 */
confirmAction() {
  this.closeModal();
}

/**
 * Cierra el modal principal
 *
 * Este método cambia la propiedad `showModal` a `false`
 * para cerrar el modal que fue previamente abierto.
 *
 * @showModal -> se establece en falso para cerrar el modal
 */
closeModal() {
  this.showModal = false;
}

    close(): void {

    this.dialogRef.close(null);
  }


/**
 * Ajusta la posición de un elemento para asegurar que permanezca dentro de los límites del viewport
 *
 * Versión corregida que utiliza viewport del navegador en lugar de la pantalla completa
 */
adjustElementPosition(pickerElement: HTMLElement, inputRect: DOMRect): void {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Guardar la posición original para cálculo de ajustes
  const originalTop = parseFloat(pickerElement.style.top) || pickerRect.top;
  const originalLeft = parseFloat(pickerElement.style.left) || pickerRect.left;

  // Ajuste vertical - si no cabe abajo, mostramos arriba del input
  if (pickerRect.bottom > viewportHeight) {
    const newTop = inputRect.top + window.scrollY - pickerRect.height;
    pickerElement.style.top = `${Math.max(10, newTop)}px`; // Mínimo 10px del borde superior
  }

  // Ajuste horizontal - si no cabe a la derecha, alineamos a la izquierda
  if (pickerRect.right > viewportWidth) {
    const newLeft = Math.max(10, viewportWidth - pickerRect.width - 10);
    pickerElement.style.left = `${newLeft}px`;
  }

  // Ajuste adicional: si se sale por arriba después del ajuste
  const finalRect = pickerElement.getBoundingClientRect();
  if (finalRect.top < 10) {
    pickerElement.style.top = '10px';
  }

  // Ajuste adicional: si se sale por la izquierda
  if (finalRect.left < 10) {
    pickerElement.style.left = '10px';
  }
}

/**
 * Abre y posiciona el date picker correctamente en el viewport
 * Versión mejorada con manejo de viewport del navegador
 */
openDatePickerSimple(): void {
  if (this.picker && this.componentResults) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;

      const inputElement = document.querySelector('.input-search-box') as HTMLElement;
      if (pickerElement && inputElement) {
        // Obtener posición del input relativa al viewport
        const inputRect = inputElement.getBoundingClientRect();

        // Aplicar estilos para posicionamiento fixed respecto al viewport
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        pickerElement.style.left = `${inputRect.left + window.scrollX}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.maxHeight = 'none';
        pickerElement.style.overflow = 'visible';
        pickerElement.style.zIndex = '9999';

        // Forzar reflow para asegurar que los estilos se aplican
        pickerElement.getBoundingClientRect();

        // Ajustar posición si es necesario
        this.adjustElementPosition(pickerElement, inputRect);
      }
    }, 50); // Aumentar ligeramente el timeout para asegurar renderizado
  }

        const mdPicker = document.querySelector('.md-drppicker');
        if (mdPicker) {
          this.calendarSync.setup(mdPicker as HTMLElement);
        }
}

// Método para toggle del desplegable
toggleOptional(): void {
  this.isOptionalExpanded = !this.isOptionalExpanded;
}

// Opcional: Método para abrir/cerrar específicamente
openedOptional(): void {
  this.isOptionalExpanded = true;
}

closeOptional(): void {
  this.isOptionalExpanded = false;
}


incrementPassenger(): void {
  this.qtyPax++;
  this._form.get('qtyPax').setValue(this.qtyPax);
  this._addPax();
}

decrementPassenger(): void {
  this.qtyPax--;
  this._form.get('qtyPax').setValue(this.qtyPax);
  this._addPax();
}

incrementAge(index: number): void {
  const ageControl = this.paxes.at(index).get('age');
  const currentAge = Number(ageControl.value) || 18;
  const maxAge = 120;
  if (currentAge < maxAge) {
    ageControl.setValue(currentAge + 1);
  }
}

  decrementAge(index: number): void {
  const ageControl = this.paxes.at(index).get('age');
  const currentAge = Number(ageControl.value) || 18;
  const minAge = 18;
  if (currentAge > minAge) {
    ageControl.setValue(currentAge - 1);
  }
}


  /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

/**
 * Expande y posiciona estratégicamente el contenedor de configuración de pasajeros
 *
 * Este método ajusta el posicionamiento del contenedor de configuración de pasajeros
 * para que aparezca fijo en relación al elemento contenedor, con ajustes automáticos
 * para evitar que se salga de los límites del viewport.
 *
 * @returns {void}
 *
 * @prerequisites
 * - Solo ejecuta si `this.componentResults` es true
 * - Requiere que existan los elementos DOM correspondientes
 *
 * @process
 * 1. Localiza elementos DOM del contenedor y configuración
 * 2. Calcula posición basada en el contenedor padre
 * 3. Aplica estilos de posicionamiento fixed preciso
 * 4. Realiza ajustes de boundaries con `adjustElementPosition`
 *
 * @positioning
 * - Posición: fixed (respecto al viewport)
 * - Top: bottom del contenedor + scroll vertical
 * - Left: left del contenedor + scroll horizontal
 * - Z-index: 9999 (máxima prioridad visual)
 *
 * @elements
 * - .config-passenger: Elemento a posicionar
 * - .element-config-passenger: Elemento de referencia para posicionamiento
 *
 * @uses adjustElementPosition() - Para ajustes de boundaries del viewport
 */
expandedConfigPassenger(): void {

  if(this.componentResults) {
    const configPassengerElement = document.querySelector('.config-passenger') as HTMLElement;
    const configPassengerContainer = document.querySelector('.element-config-passenger') as HTMLElement;

    if(configPassengerElement && configPassengerContainer) {

      // Calculamos la posición del input en el viewport
        const inputRect = configPassengerContainer.getBoundingClientRect();

       // Ajustamos la posición del picker relativa al input
        configPassengerElement.style.position = 'fixed';


        // configPassengerElement.style.top = `${inputRect.bottom + window.scrollY}px`;
        // configPassengerElement.style.left = `${inputRect.left + window.scrollX}px`;
        configPassengerElement.style.transform = 'none';
        configPassengerElement.style.maxHeight = 'none';
        configPassengerElement.style.overflow = 'visible';
        configPassengerElement.style.zIndex = '9999';
        configPassengerElement.style.width = '30%';
        configPassengerContainer.getBoundingClientRect();

          // Verificamos si el picker se sale de la pantalla y ajustamos
        // this.adjustElementPosition(configPassengerElement, inputRect);
    }

  }

  }

  toggleDropdown(index: number, e: any): void {
    e.stopPropagation();
    // Cerrar el dropdown de semanas de embarazo en TODOS los pasajeros
    // para evitar que se solape con el de addons (son excluyentes).
    this.openPregnancyIndexes.clear();

    if (this.openDropdownIndexes.has(index)) {
      this.openDropdownIndexes.delete(index);
    } else {
      this.openDropdownIndexes.clear();
      this.openDropdownIndexes.add(index);
    }
  }

  isDropdownOpen(index: number): boolean {
    return this.openDropdownIndexes.has(index);
  }

  preventClose(event: MouseEvent): void {
    event.stopPropagation();
  }

  toggleAddon(index: number, filterValue: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const currentAddons = this.getSelectedAddons(index);
    if (checkbox.checked) {
      if (!currentAddons.includes(filterValue)) {
        currentAddons.push(filterValue);
      }
    } else {
      const i = currentAddons.indexOf(filterValue);
      if (i > -1) {
        currentAddons.splice(i, 1);
      }
    }
    this.paxes.at(index).get('addons')?.setValue([...currentAddons]);
  }

  isAddonSelected(index: number, filterValue: string): boolean {
    return this.getSelectedAddons(index).includes(filterValue);
  }

  getSelectedAddons(index: number): string[] {
    const addonsControl = this.paxes.at(index)?.get('addons');
    return addonsControl?.value || [];
  }

  getSelectedAddonsLabels(index: number): string {
    const selected = this.getSelectedAddons(index);
    return selected
      .map(key => this.passengerFilter.find(f => f.filter === key)?.label || key)
      .join(', ');
  }

  togglePregnancyDropdown(index: number, e: any): void {
    e.stopPropagation();
    // Cerrar el dropdown de addons en TODOS los pasajeros
    // para evitar que se solape con el de semanas (son excluyentes).
    this.openDropdownIndexes.clear();

    if (this.openPregnancyIndexes.has(index)) {
      this.openPregnancyIndexes.delete(index);
    } else {
      this.openPregnancyIndexes.clear();
      this.openPregnancyIndexes.add(index);
    }
  }

  isPregnancyDropdownOpen(index: number): boolean {
    return this.openPregnancyIndexes.has(index);
  }

  selectPregnancyWeek(index: number, week: number): void {
    this.paxes.at(index).get('pregnancyWeeks')?.setValue(week);
    this.openPregnancyIndexes.delete(index);
  }

  private updateCheckboxColor() {
    const dynamicColor = '#000000';
    const checkboxes = document.querySelectorAll('.custom-multiselect .custom-checkbox:checked');
    checkboxes.forEach((checkbox: Element) => {
      const htmlCheckbox = checkbox as HTMLElement;
      this.renderer.setStyle(htmlCheckbox, 'accent-color', dynamicColor);
    });
  }

}
